<template>
  <section
    :id="sectionId || undefined"
    class="games-section providers-section"
    :class="{ 'providers-section--category': isGridLayout }"
  >
    <div class="section-header">
      <div class="section-header__title">
        <h2>{{ title }}</h2>
      </div>
      <div v-if="showHeaderActions && carouselItemCount" class="section-header__actions">
        <a
          v-if="showCarouselNav"
          href="#"
          class="section-header__more"
          @click.prevent="toggleCarouselExpanded"
        >{{ carouselExpanded ? $t('games.collapse') : $t('games.expand') }}</a>
        <div v-if="showCarouselNav" class="carousel-nav">
          <button
            type="button"
            class="carousel-nav__btn"
            :disabled="!carouselCanPrev"
            :aria-label="$t('common.prev')"
            @click="carouselPrev"
          >
            ‹
          </button>
          <button
            type="button"
            class="carousel-nav__btn"
            :disabled="!carouselCanNext"
            :aria-label="$t('common.next')"
            @click="carouselNext"
          >
            ›
          </button>
        </div>
      </div>
    </div>

    <p v-if="subtitle" class="providers-section__subtitle">{{ subtitle }}</p>

    <p v-if="loading" class="games-section__status">{{ $t('games.loadingProviders') }}</p>
    <p v-else-if="loadError" class="games-section__status games-section__status--error">{{ loadError }}</p>
    <p v-else-if="!carouselItems.length" class="games-section__status">{{ $t('games.emptyProviders') }}</p>

    <div
      v-else
      class="games-carousel providers-carousel"
      :class="{
        'games-carousel--step': showCarouselNav,
        'games-carousel--static': isGridLayout || carouselExpanded || !showCarouselNav,
        'games-carousel--expanded': carouselExpanded && !isGridLayout,
        'games-carousel--category-grid': isGridLayout
      }"
    >
      <div
        class="games-carousel__track"
        :style="carouselTrackStyleLocal"
      >
        <article
          v-for="provider in carouselItems"
          :key="provider.id"
          class="game-card provider-card"
          @click="$emit('select', provider.raw)"
        >
          <div class="provider-card__media">
            <img
              v-if="provider.img"
              :src="provider.img"
              :alt="provider.name"
              loading="lazy"
              decoding="async"
              @error="onImgError(provider)"
            >
            <div v-else class="provider-card__fallback" />
          </div>
          <div class="game-info provider-card__info">
            <strong>{{ provider.name }}</strong>
          </div>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
import { normalizeProviders } from '@/utils/provider'
import gameCarouselStep from '@/mixins/gameCarouselStep'

export default {
  name: 'BlackGoldProviders',
  mixins: [gameCarouselStep],
  props: {
    providers: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    loadError: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default () {
        return this.$t('games.providersTitle')
      }
    },
    subtitle: {
      type: String,
      default: ''
    },
    sectionId: {
      type: String,
      default: ''
    },
    layout: {
      type: String,
      default: 'carousel',
      validator: value => ['carousel', 'grid'].includes(value)
    },
    showHeaderActions: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      brokenImages: {}
    }
  },
  computed: {
    isGridLayout () {
      return this.layout === 'grid'
    },
    showCarouselNav () {
      return !this.isGridLayout && this.carouselShowNav
    },
    carouselTrackStyleLocal () {
      if (this.isGridLayout) return null
      return this.carouselTrackStyle
    },
    carouselItems () {
      return normalizeProviders(this.providers).map((provider, index) => ({
        id: `provider-${provider.idx}-${index}`,
        name: provider.displayName || provider.name,
        img: this.brokenImages[provider.filename] ? '' : provider.image,
        raw: provider
      }))
    }
  },
  methods: {
    onImgError (provider) {
      const key = provider && provider.raw && provider.raw.filename
      if (key) {
        this.$set(this.brokenImages, key, true)
      }
    }
  }
}
</script>
